const freeMap = {
  // 免费领商品列表
  getFreeProductList: '/usb/uwb-app/api/v1/takeFree/product/list',
  // 滚动消息 get
  getListRolling: '/usb/uwb-app/api/v1/takeFree/activity/listRollingBroadcast',
  // 免费拿助力
  getFreeHelp: '/usb/uwb-app/api/v1/takeFree/doHelp/add',
  // 被分享者进度展示 get
  getShowProgress: '/usb/uwb-app/api/v1/takeFree/doHelp/show',
  // 领取中进度展示 get
  getHelpProgress: '/usb/uwb-app/api/v1/takeFree/help/show',
  // 参与活动
  getTaskActivity: '/usb/uwb-app/api/v1/takeFree/activity/participate',
  // 生成免费领分享链接
  getShareLink: '/usb/uwb-app/api/v1/takeFree/getShareLink',
  // 弹窗修改状态
  getPopupStatus: '/usb/uwb-app/api/v1/takeFree/help/updateAlert',
};

export default freeMap;
